import { render, staticRenderFns } from "./ScreensListItem.vue?vue&type=template&id=31c18bac&"
import script from "./ScreensListItem.vue?vue&type=script&lang=js&"
export * from "./ScreensListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports